import { hudPaths } from '../content';
import { CommunicationsScreen } from '../sections';
import { PageActionBar } from './PageActionBar';

export const CommunicationsPage = () => {
  return (
    <>
      <CommunicationsScreen />
      <PageActionBar activePath={hudPaths.communicationsTerminal} ctaLabel="Transmit Request Packet" />
    </>
  );
};
